<template>
    <div class="min-h-screen bg-gray-50">
        <!-- 复用Header组件 -->
        <Header />
        <div class="container mx-auto py-6 pb-16">
            <div class="flex flex-col lg:flex-row gap-8">
                <div class="product-market w-full">
                    <section class="market-header">
                        <h1>吉林省数字产品超市</h1>
                        <p>汇聚优质数字产品，服务企业数字化转型，一站式采购与服务平台</p>
                    </section>

                    <section class="search-box">
                        <div class="search-input">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
                            <input v-model="searchForm.name" type="text" placeholder="搜索产品名称...">
                        </div>
                        <select v-model="searchForm.category" class="filter-select" @change="searchForm.domain = ''">
                            <option value="">全部分类</option>
                            <option v-for="item in categoryList" :key="item.dictCode" :value="item.dictValue">{{ item.dictLabel }}</option>
                        </select>
                        <select v-model="searchForm.domain" class="filter-select">
                            <option value="">全部领域</option>
                            <option v-for="item in domainsList" :key="item.dictCode" :value="item.dictValue">{{ item.dictLabel }}</option>
                        </select>
                        <button class="search-btn" type="button" @click="search()">搜索</button>
                    </section>

                    <div class="cat-tabs">
                        <button class="cat-tab" :class="{ active: !searchForm.category }" type="button" @click="selectCategory('')">全部产品</button>
                        <button v-for="item in categoryList" :key="item.dictCode" class="cat-tab" :class="{ active: searchForm.category === item.dictValue }" type="button" @click="selectCategory(item.dictValue)">{{ getDictLabelByValue(item.dictValue) }}</button>
                    </div>
                    <div class="domain-tags">
                        <button class="domain-tag" :class="{ active: !searchForm.domain }" type="button" @click="selectDomain('')">全部</button>
                        <button v-for="item in domainsList" :key="item.dictCode" class="domain-tag" :class="{ active: searchForm.domain === item.dictValue }" type="button" @click="selectDomain(item.dictValue)">{{ getDictLabelByValue(item.dictValue) }}</button>
                    </div>

                    <div class="stats-bar">
                        <div class="flex justify-between items-center">
                            <span>共 <strong>{{ searchForm.total }}</strong> 款产品</span>
                            <div class="pagination">
                                <button @click="changePage(searchForm.pageNum - 1)" :disabled="searchForm.pageNum <= 1" class="page-btn">&lt; 上一页</button>
                                <span class="page-info">第 {{ searchForm.pageNum }} 页</span>
                                <button @click="changePage(searchForm.pageNum + 1)" :disabled="searchForm.pageNum >= totalPages" class="page-btn">下一页 ></button>
                                <span>共 {{ totalPages }} 页</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="filteredProducts.length" class="product-grid">
                        <router-link v-for="item in filteredProducts" :key="item.id" class="product-card" :to="'/productDetail/' + item.id">
                            <div class="product-img">
                                <img v-if="item.imageUrl" :src="getFullImageUrl(item.imageUrl)" :alt="item.name">
                                <svg v-else width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#aac" stroke-width="1.2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
                                <span v-if="item.discount" class="discount-badge">{{ discountText(item.discount) }}</span>
                            </div>
                            <div class="product-body">
                                <h3 class="product-name">{{ item.name }}</h3>
                                <div class="product-tags">
                                    <span>{{ getDictLabelByValue(item.category) }}</span>
                                    <span>{{ getDictLabelByValue(item.domain) }}</span>
                                </div>
                                <p class="product-desc">{{ item.description }}</p>
                                <div class="product-footer">
                                    <div>
                                        <div v-if="item.discount" class="price-original">&yen;{{ price(item.price) }}</div>
                                        <div class="price-current"><span>&yen;</span>{{ price(item.discount ? item.memberPrice : item.price) }}</div>
                                        <div v-if="item.discount" class="price-member">会员价（{{ discountText(item.discount) }}）</div>
                                    </div>
                                    <div class="product-supplier">{{ item.companyName }}</div>
                                </div>
                            </div>
                        </router-link>
                    </div>

                    <div v-else class="empty-state">暂无匹配的产品</div>

                    <h2 class="section-title">典型案例</h2>
                    <div class="case-grid" v-if="caseList.length">
                        <div v-for="item in caseList" :key="item.name" class="case-card">
                            <h3>{{ item.name }}</h3>
                            <div>{{ item.companyName }}</div>
                            <p>{{ item.description }}</p>
                        </div>
                    </div>
                    <div v-else class="empty-state">暂无案例</div>

                    <div class="bottom-sections">
                        <div class="info-card">
                            <h3>会员企业权益</h3>
                            <ul><li v-for="item in memberBenefits" :key="item">{{ item }}</li></ul>
                            <div class="contact-info">咨询热线：0431-XXXX-XXXX<br>邮箱：member@jlsia.org.cn</div>
                        </div>
                        <div class="info-card">
                            <h3>合作伙伴权益</h3>
                            <ul><li v-for="item in partnerBenefits" :key="item">{{ item }}</li></ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import Header from '../components/Header.vue'
import AppFooter from '../components/Footer.vue'
import {CURRENT_CONFIG} from "@/api/config";
import {api} from "@/api";
export default {
    name: 'ProductList.vue',
    components: {
        Header,
        AppFooter
    },
    data() {
        return {
            dictList: [],
            searchForm: {
                name: '',
                category: '',
                domain: '',
                pageNum: 1,
                pageSize: 9,
                total: 0
            },
            currentPage: 1,
            activeCategory: '',
            activeDomain: '',
            activeSearch: '',
            loading: false,
            BASE_URL: CURRENT_CONFIG.BASE_URL,
            productList: [],
            caseList: [],
            memberBenefits: ['享受全部产品会员专属折扣价格', '优先获取新产品试用资格与技术支持', '参与行业论坛、技术沙龙等会员活动', '享有定制化解决方案咨询服务', '获得协会颁发的会员证书与授牌'],
            partnerBenefits: ['产品入驻数字产品超市，扩大市场曝光', '参与协会组织的供需对接与推介活动', '共享协会政企资源与销售渠道', '获得平台运营数据与市场分析报告', '优先参与行业标准制定与课题研究']
        }
    },
    computed: {
        categoryList() {
            if (this.dictList.length > 0) {
                return this.dictList.filter(item => item.dictValue.length === 3)
            }
            return []
        },
        domainsList() {
            if (this.dictList.length > 0) {
                if (this.searchForm.category !== '') {
                    return this.dictList.filter(item => item.dictValue.length === 6 && item.dictValue.substring(0, 3) === this.searchForm.category)
                } else {
                    return this.dictList.filter(item => item.dictValue.length === 6)
                }
            }
            return []
        },
        filteredProducts() {
            const keyword = this.activeSearch.trim().toLowerCase()
            return this.productList.filter(item => (!keyword || item.name.toLowerCase().includes(keyword) || item.companyName.toLowerCase().includes(keyword) || item.description.toLowerCase().includes(keyword)) && (!this.activeCategory || item.category === this.activeCategory) && (!this.activeDomain || item.domain === this.activeDomain))
        },
        totalPages() {
            return Math.ceil(this.searchForm.total / this.searchForm.pageSize);
        }
    },
    watch: {
        // 监听领域选择的变化
        'searchForm.domain'(newVal) {
            // 当领域有值且分类为空时，将分类设置为领域的前3位字符
            if (newVal && !this.searchForm.category) {
                this.searchForm.category = newVal.substring(0, 3);
            }
        }
    },
    mounted() {
        this.getDataDictList()
        this.getProductList()
        this.getProductCaseList()
    },
    methods: {
        selectCategory(category) {
            this.searchForm.category = category
            this.searchForm.domain = ''
            this.search()
        },
        selectDomain(domain) {
            // 当分类为空且选择了领域时，自动将分类设置为领域的前3位字符
            if (domain && !this.searchForm.category) {
                this.searchForm.category = domain.substring(0, 3);
            }
            this.searchForm.domain = domain;
            this.search()
        },
        price(value) {
            return value.toLocaleString()
        },
        discountText(value) {
            return `${Number(value).toFixed(1).replace(/\.0$/, '')}折`
        },
        // 根据字典值获取对应的标签文字
        getDictLabelByValue(value) {
            if (!value) return '';
            const dictItem = this.dictList.find(item => item.dictValue === value);
            return dictItem ? dictItem.dictLabel : value;
        },
        search() {
            this.currentPage = 1;
            this.searchForm.pageNum = 1;
            this.getProductList()
        },
        changePage(page) {
            if (page < 1 || page > this.searchForm.total) return;
            this.searchForm.pageNum = page;
            this.getProductList();
        },
        // 获取产品列表
        async getProductList() {
            this.productList = []
            const result = await api.getDigitalProducts(this.searchForm.name, this.searchForm.category, this.searchForm.domain, this.searchForm.pageNum, this.searchForm.pageSize)
            if (result.code === 200) {
                this.productList = result.rows
                this.searchForm.total = result.total
            }
        },
        // 获取典型案例
        async getProductCaseList() {
            this.caseList = []
            const result = await api.getProductCaseListApi()
            if (result.code === 200) {
                this.caseList = result.rows
            }
        },
        // 获取数据字典
        async getDataDictList() {
            this.dictList = []
            const dictType = 'biz_digital_product_type'
            const result = await api.getDataDictApi(dictType)
            if (result.code === 200) {
                this.dictList = result.rows
            }
        },
        getFullImageUrl(path) {
            return this.BASE_URL + path
        },
    }
}
</script>

<style scoped>
.product-market { color: #333; }
.market-header { background: linear-gradient(135deg, #1a3a6b, #2d6bc4); color: #fff; border-radius: 16px; padding: 64px 24px 140px; text-align: center; }
.market-header h1 { font-size: 36px; font-weight: 700; margin-bottom: 12px; }
.market-header p { opacity: .86; }
.search-box { margin: -100px auto 70px; max-width: 1040px; background: #fff; border-radius: 16px; padding: 10px 10px; box-shadow: 0 12px 36px rgba(26,58,107,.16); display: flex; align-items: center; gap: 16px; flex-wrap: wrap; position: relative; z-index: 1; }
.search-input { flex: 1; min-width: 240px; position: relative; }
.search-input svg { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #999; }
.search-input input, .filter-select { width: 100%; padding: 10px 16px; border: 1px solid #d9d9d9; border-radius: 8px; outline: none; background: #fff; }
.search-input input { padding-left: 40px; }
.filter-select { width: auto; min-width: 140px; }
.search-btn { padding: 10px 28px; background: #2d6bc4; color: #fff; border: 0; border-radius: 8px; cursor: pointer; }
.cat-tabs { display: flex; background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,.06); margin-bottom: 20px; }
.cat-tab { flex: 1; padding: 14px 20px; color: #666; border: 0; border-bottom: 3px solid transparent; background: transparent; cursor: pointer; }
.cat-tab.active, .cat-tab:hover { color: #2d6bc4; background: #f5f8ff; border-bottom-color: #2d6bc4; font-weight: 600; }
.domain-tags { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 24px; }
.domain-tag { padding: 6px 16px; background: #fff; border: 1px solid #d9d9d9; border-radius: 20px; color: #666; cursor: pointer; }
.domain-tag.active, .domain-tag:hover { background: #2d6bc4; color: #fff; border-color: #2d6bc4; }
.stats-bar { margin-bottom: 20px; color: #999; }
.stats-bar strong { color: #2d6bc4; font-size: 18px; }
.product-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 32px; }
.product-card { background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 12px rgba(0,0,0,.06); transition: all .3s; color: inherit; text-decoration: none; }
.product-card:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,.12); }
.product-img { height: 180px; background: linear-gradient(135deg, #e8f0fe, #d4e4fc); display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden; }
.product-img img { max-height: 100%; max-width: 100%; object-fit: cover; width: auto; }
.discount-badge { position: absolute; top: 12px; right: 12px; background: #e6453a; color: #fff; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; }
.product-body { padding: 18px; }
.product-name { font-size: 16px; font-weight: 600; margin-bottom: 8px; color: #1a1a2e; }
.product-tags { display: flex; gap: 6px; margin-bottom: 10px; flex-wrap: wrap; }
.product-tags span { padding: 2px 10px; background: #f0f5ff; color: #2d6bc4; border-radius: 4px; font-size: 12px; }
.product-desc { font-size: 13px; color: #999; margin-bottom: 12px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.6; }
.product-footer { display: flex; justify-content: space-between; align-items: flex-end; border-top: 1px solid #f0f0f0; padding-top: 12px; }
.price-original { font-size: 12px; color: #bbb; text-decoration: line-through; }
.price-current { font-size: 22px; font-weight: 700; color: #e6453a; }
.price-current span, .price-member { font-size: 12px; font-weight: 400; }
.price-member { color: #2d6bc4; }
.product-supplier { font-size: 12px; color: #999; text-align: right; max-width: none; white-space: nowrap; }
.empty-state { background: #fff; border-radius: 12px; text-align: center; color: #999; padding: 60px 20px; margin-bottom: 32px; }
.section-title { font-size: 20px; font-weight: 700; color: #1a1a2e; margin-bottom: 20px; padding-bottom: 12px; border-bottom: 2px solid #f0f0f0; position: relative; }
.section-title::after { content: ''; position: absolute; bottom: -2px; left: 0; width: 60px; height: 2px; background: #2d6bc4; }
.case-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 40px; }
.case-card, .info-card { background: #fff; border-radius: 12px; padding: 24px; box-shadow: 0 2px 12px rgba(0,0,0,.06); }
.case-card h3, .info-card h3 { font-size: 16px; font-weight: 600; color: #1a1a2e; margin-bottom: 8px; }
.case-card div { font-size: 13px; color: #2d6bc4; margin-bottom: 10px; font-weight: 500; }
.case-card p { font-size: 13px; color: #999; line-height: 1.7; }
.bottom-sections { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
.info-card ul { list-style: none; padding: 0; margin: 0; }
.info-card li { padding: 8px 0; font-size: 14px; color: #666; }
.info-card li::before { content: ''; display: inline-block; width: 6px; height: 6px; background: #2d6bc4; border-radius: 50%; margin-right: 8px; vertical-align: middle; }
.contact-info { margin-top: 12px; padding: 12px; background: #f5f8ff; border-radius: 8px; font-size: 14px; color: #2d6bc4; }
@media (max-width: 900px) { .product-grid { grid-template-columns: repeat(2, 1fr); } .case-grid, .bottom-sections { grid-template-columns: 1fr; } }
.pagination {
    display: flex;
    align-items: center;
    gap: 12px;
}

.page-btn {
    padding: 6px 12px;
    background: #f0f0f0;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.page-btn:hover:not(:disabled) {
    background: #e6f7ff;
    border-color: #1890ff;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    font-size: 14px;
    color: #666;
}

.page-size {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
}

.page-size-select {
    width: 70px;
    padding: 4px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
}

@media (max-width: 600px) { .product-grid { grid-template-columns: 1fr; } .cat-tabs { flex-direction: column; } }
</style>
